import { hasAnyRole } from '../../utils/roles';
import { ROLES } from '../../utils/roles';

const { ROLE_OWNER, ROLE_ADMINISTRATOR, ROLE_FINANCE, ROLE_READ_ONLY } = ROLES;

const ALLOWED_ROLES_VIEW_BANK_ACCOUNTS = [ROLE_OWNER, ROLE_ADMINISTRATOR, ROLE_FINANCE, ROLE_READ_ONLY];

const ALLOWED_ROLES_CREATE_BANK_ACCOUNT = [ROLE_OWNER, ROLE_ADMINISTRATOR, ROLE_FINANCE];

const ALLOWED_ROLES_DELETE_BANK_ACCOUNT = [ROLE_OWNER, ROLE_ADMINISTRATOR, ROLE_FINANCE];

export function canViewBankAccounts(roles: string[]): boolean {
  return hasAnyRole(roles, ALLOWED_ROLES_VIEW_BANK_ACCOUNTS);
}

export function canCreateBankAccount(roles: string[]): boolean {
  return hasAnyRole(roles, ALLOWED_ROLES_CREATE_BANK_ACCOUNT);
}

export function canDeleteBankAccount(roles: string[]): boolean {
  return hasAnyRole(roles, ALLOWED_ROLES_DELETE_BANK_ACCOUNT);
}
